// 获取当前节点对应的表单节点 form-v3
export const useParentEl = (currentEl, nodeClass) => {
    const getParentEl = (el) => {
        if (!el) {return null;}
        const parentEl =  el.parentNode;
        if (parentEl && [].slice.call(parentEl.classList || []).includes(nodeClass)) {
            return parentEl;
        }
        else {return getParentEl(parentEl);}
    }
    return getParentEl(currentEl);
}